/**
 * useRulesContext — Hook to consume rule overrides from the RulesProvider context.
 *
 * Separated from RulesProvider.tsx to satisfy React Fast Refresh
 * (only components should be exported from component files).
 */
import { use } from "react";
import { RulesContext, type RulesContextValue } from "./RulesContext";

export function useRulesContext(): RulesContextValue {
	const ctx = use(RulesContext);
	if (!ctx) {
		throw new Error("useRulesContext must be used within a <RulesProvider>");
	}
	return ctx;
}
